var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"index"},[_c('img',{attrs:{"src":require("@/assets/img/white-logo.svg"),"alt":""}}),_c('div',{staticClass:"title fugaz"},[_vm._v(" LOADING "),_vm._l((_vm.dots),function(dot){return _c('span',[_vm._v(". ")])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }